import type { TableRow } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

import type { FromPMHandlers } from '../types';
import { getHandler } from '../utils';

export function table(
	node: PMNode,
	handlers: FromPMHandlers,
): { children: TableRow[]; type: 'table' } {
	const rows: TableRow[] = [];
	node.forEach((child) => {
		const handler = getHandler(handlers, child.type.name);
		if (handler) {
			const result = handler(child);
			if (result && !Array.isArray(result) && result.type === 'tableRow') {
				rows.push(result as TableRow);
			}
		}
	});
	return { type: 'table' as const, children: rows };
}
